<template>
  <div>
    <modal
      class="confirmation-modal"
      width="800px"
      :value="showModal"
      effect="fade"
      @closed="closed"
      large
    >
      <!-- custom header -->
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
          <strong>お知らせ</strong>
        </h4>
          <center >
            <!--<span  v-if="isUserIDOperationInCharge == false">-->
           <!--     <table style="width: 90%; max-width:400px; text-align: center;background:white;font-weight: bold;border: #404040 1px solid;">
                 <tr  style="background: #b4d5f1;">
                <td colspan="2">ライセンス通知</td>
                 </tr>
                 <tr>
                  <td style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: left;" > ３ヵ月以内に有効期限が切れるライセンス</td>
                  <td  style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: right;width: 100px;">{{certificateThatExpiresIn3Months}}件</td>
                 </tr>
                 <tr>
                  <td style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: left;" >有効期限切れライセンス</td>
                  <td  style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: right;width: 100px;">{{certificateExpiredLicense}}件</td>
                 </tr>
              </table>
              <table style="width: 90%; max-width:400px; text-align: center;background:white;font-weight: bold;border: #404040 1px solid;">
                 <tr  style="background: #b4d5f1;">
                   <td colspan="2">未承認通知</td>
                 </tr>
                 <tr>
                  <td style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: left;" > 申請承認（申請中）</td>
                  <td  style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: right;width: 100px;">{{applicationApprovalPending}}件</td>
                 </tr>
              　　<tr>
                  <td style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: left;" > 申請承認（差戻）</td>
                  <td  style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: right;width: 100px;">{{applicationApprovalRejection}}件</td>
                 </tr>
                 <tr>
                  <td style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: left;" > 一括取込（申請中）</td>
                  <td  style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: right;width: 100px;">{{bulkImportPending}}件</td>
                 </tr>
                　<tr>
                  <td style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: left;" > 一括取込（差戻）</td>
                  <td  style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: right;width: 100px;">{{bulkImportRejection}}件</td>
                 </tr>
              </table> -->
              <!--<table style="width: 90%; max-width:400px; text-align: center;background:white;font-weight: bold;border: #404040 1px solid;" v-if="isMultiCompanyAdmin && pwApprovalHistory !== false">
                 <tr  style="background: #b4d5f1;">
                   <td colspan="2">PWロック解除申請</td>
                 </tr>
                 <tr>
                  <td style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: left;" > PWロック解除(申請中)</td>
                  <td  style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: right;width: 100px;">{{pwApprovalHistory}}件</td>
                 </tr>
              </table>


              <table style="width: 90%; max-width:400px; text-align: center;background:white;font-weight: bold;border: #404040 1px solid;" v-if="isMultiCompanyAdmin">
                 <tr  style="background: #b4d5f1;">
                   <td colspan="2">余剰ライセンス</td>
                 </tr>
                 <tr>
                  <td style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: left;" > 3ヵ月以内に有効期限が切れる余剰ライセンス</td>
                  <td  style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: right;width: 100px;">{{surplusLicenseThatExpiresIn3Months}}件</td>
                 </tr>
                 <tr>
                  <td style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: left;" >有効期限切れ余剰ライセンス</td>
                  <td  style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: right;width: 100px;">{{surplusExpiredLicense}}件</td>
                 </tr>
              </table>
            </span>-->
              <table
                v-if="loginExpireDays < 31"
                style="width: 90%; max-width:400px; text-align: center;background:white;font-weight: bold;border: #404040 1px solid;">
                 <tr  style="background: #b4d5f1;">
                  <td colspan="2">パスワード通知</td>
                 </tr>
                 <tr>
                  <td style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: left;" > パスワード有効期限まで残り</td>
                  <td  style="font-size: 12px;padding:4px;border: #404040 1px solid;text-align: right;">{{loginExpireDays}}日</td>
                 </tr>
              </table>
          </center>
      </div>
      <div
        class="modal-body notice-modal-body"
        style="height: 280px; padding: 5px 15px; overflow-x: auto"
      >
        <div>
          <div v-for="n in listOfNotices" :key="n.seq_id">
            <div v-if="processImportance(n.importance).length > 0">
              <span class="message_label">重要度: </span>
              <span v-html="processImportance(n.importance)" />
            </div>
            <div>
              <span class="message_label">送信者: </span>
              {{ n.from_user_shimei || n.from_user }}
              <span class="message_label">宛先: </span
              >{{ processnToUserShimei(n) }}
            </div>
            <div>
              <span class="message_label">登録日: </span> {{ n.create_date }}
            </div>
            <div style="margin-top: 5px" v-html="n.message"></div>
            <hr />
          </div>
        </div>
      </div>
      <div slot="modal-footer" class="modal-footer" style="background: white">
        <button type="button" class="btn btn-primary" @click="closed('yes')">
          完了
        </button>
      </div>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import md5 from "md5";
import { bus } from "@/libs/bus";
import { utils } from "@/libs/utils";
import { fields, filed_types } from "@/rules/fields_notice";
var vm = this;
import acl from "@/rules/acl_rules";
import modal from "./local-modal";
Vue.component("modal", modal);
import debug from "debug";
import constants from '../../rules/constants';
var debug_msg = debug("esma:notice-modal");
export default {
  data() {
    return {
      show_modal: false,
      callback: null,
      api_name: "notice",
      page_acl: acl.generic,
      list_of_notices: [],
      // notification_certificate_over_qty:0,
      // notification_certificate_qty:0,
      // approval_history_qty:0,
      // approval_history_All_qty:0,
      login_expire_days:9999,
      certificate_that_expires_in_3_months:"^",
      certificate_expired_license:"^",
      application_approval_pending:"^",
      application_approval_rejection:"^",
      bulk_import_pending:"^",
      bulk_import_rejection:"^",
      surplus_license_that_expires_in_3_months:"^",
      surplus_expired_license:"^",
      pw_approval_history:"^",
      schedule_interval:false
    };
  },
  computed: {
    isMultiCompanyAdmin(){
      var role = Vue.localStorage.get("userRole")
      return role == "保守担当" || role == "システム管理者";
    },
    isUserIDOperationInCharge(){
      var role = Vue.localStorage.get("userRole")
      return role == "ユーザIDオペレーション担当者";
    },
    pwApprovalHistory:{
      get(){
        return this.pw_approval_history;
      },
      set(v){
        this.pw_approval_history = v;
      }
    },
     certificateThatExpiresIn3Months:{
      get(){
        return this.certificate_that_expires_in_3_months;
      },
      set(v){
        this.certificate_that_expires_in_3_months = v;
      }
    },
    certificateExpiredLicense:{
      get(){
        return this.certificate_expired_license;
      },
      set(v){
        this.certificate_expired_license = v;
      }
    },
    applicationApprovalPending:{
      get(){
        return this.application_approval_pending;
      },
      set(v){
        this.application_approval_pending = v;
      }
    },
    applicationApprovalRejection:{
      get(){
        return this.application_approval_rejection;
      },
      set(v){
        this.application_approval_rejection = v;
      }
    },
    bulkImportPending:{
      get(){
        return this.bulk_import_pending;
      },
      set(v){
        this.bulk_import_pending = v;
      }
    },
    bulkImportRejection:{
      get(){
        return this.bulk_import_rejection;
      },
      set(v){
        this.bulk_import_rejection = v;
      }
    },
    surplusLicenseThatExpiresIn3Months:{
      get(){
        return this.surplus_license_that_expires_in_3_months;
      },
      set(v){
        this.surplus_license_that_expires_in_3_months = v;
      }
    },
    surplusExpiredLicense:{
      get(){
        return this.surplus_expired_license;
      },
      set(v){
        this.surplus_expired_license = v;
      }
    },
    loginExpireDays:{
      get(){
        return this.login_expire_days;
      },
      set(v){
        this.login_expire_days = v;
      }
    },
    listOfNotices: {
      get() {
        return this.list_of_notices;
      },
      set(v) {
        this.list_of_notices = v;
      },
    },
    showModal: {
      get() {
        return this.show_modal;
      },
      set(v) {
        this.show_modal = v;
      },
    },
  },
  methods: {
    processImportance(i) {
      if (i == null || (i + "").trim() == "") {
        return "";
      }
      var ret = "";
      var found = _.find(fields.importance.options, (o) => {
        return o.value == i;
      });
      if (found && typeof found != "undefined") {
        if (found.label == "") {
          return "";
        }
        if (found.style && found.style.length > 0) {
          ret += "<span style='" + found.style + "'>" + found.label + "<span>";
        } else {
          ret += "<span>" + found.label + "<span>";
        }
      } else {
        ret += "<span>" + i + "<span>";
      }
      return ret;
    },
    processnToUserShimei(data) {
      if (data.to_company == constants.COMMON.ALL_USERS_VALUE) {
        return constants.COMMON.ALL_USERS_LABEL;
      }else if(data.to_team && data.to_team.length > 0 ) {
        return data.to_company + " " + data.to_department + " " + data.to_team;
      }else if(data.to_department && data.to_department.length > 0 ) {
        return data.to_company + " " + data.to_department;
      }else if(data.to_company && data.to_company.length > 0 ) {
        return data.to_company;
      } 
      // else {
      //   return data.to_user_shimei;
      // }
    },
    showNoticeData(counter_data,message_data){
        var show_the_modal = true
        if ( message_data && typeof message_data != "undefined" && Array.isArray(message_data) && message_data.length > 0 ) {
          message_data.forEach(r=>{
            r.message = r.message.replace(/\n/g,"<br>")
          })

          this.listOfNotices = _.filter(message_data,(d=>{ return d.message_schedule == null || moment(d.message_schedule).diff(new Date(),"seconds") <= 0 }));
          var hash = md5(JSON.stringify(this.listOfNotices))
          if(window.sessionStorage.getItem('last_show_notification_hash') == hash){
            show_the_modal = false
          }
          window.sessionStorage.setItem('last_show_notification_hash', hash)

          var noticies_for_schedule = _.filter(message_data,(d=>{ return d.message_schedule != null && moment(d.message_schedule).diff(new Date(),"seconds") > 0 }));
          if(Array.isArray(noticies_for_schedule) && noticies_for_schedule.length > 0){
            var arr = [];
            message_data.forEach(e=>{
              if(e.message_schedule && ((new Date(e.message_schedule)).getTime() > (new Date()).getTime())){
                arr.push(e.message_schedule)
              }
            })
            if(arr.length > 0){
              Vue.localStorage.set("noticiesForSchedule", JSON.stringify(arr.sort()))
              setTimeout(() => {
                this.checkNoticiesForSchedule(this);
              }, 1000);
            }else{
              Vue.localStorage.set("noticiesForSchedule", false)
            }
          }else{
            Vue.localStorage.set("noticiesForSchedule", false)
          }

          if( isNaN(this.loginExpireDays) == false && parseInt(this.loginExpireDays) < 31){
            show_the_modal = true;
          }else if(Array(this.listOfNotices) && this.listOfNotices.length > 0){
            this.showModal = show_the_modal == true;
          }else{
            show_the_modal = false
          }

        } else {
          this.showModal = false;
        }
        this.certificateThatExpiresIn3Months = counter_data.all_counters.certificate_that_expires_in_3_months;
        this.certificateExpiredLicense = counter_data.all_counters.certificate_expired_license;
        this.applicationApprovalPending = counter_data.all_counters.application_approval_pending;
        this.applicationApprovalRejection = counter_data.all_counters.application_approval_rejection;
        this.bulkImportPending = counter_data.all_counters.bulk_import_pending;
        this.bulkImportRejection = counter_data.all_counters.bulk_import_rejection;
        this.surplusLicenseThatExpiresIn3Months = counter_data.all_counters.surplus_license_that_expires_in_3_months;
        this.surplusExpiredLicense = counter_data.all_counters.surplus_expired_license;
        this.pwApprovalHistory = counter_data.all_counters.pw_approval_history || false;
        if( isNaN(this.loginExpireDays) == false && parseInt(this.loginExpireDays) < 31){
            this.showModal =  show_the_modal == true;
        }else if(Array(this.listOfNotices) && this.listOfNotices.length > 0){
          this.showModal =  show_the_modal == true;
        }else{
          this.showModal = false;
        }
        this.$store.state.show_message_after_login = false;
    },
    loadAllCounters(cb){
      this.$ajax.post('/common/load_menu_counters/', {}, (err, result) => {
        cb(err,result);
      })
    },
    processNoticeModalSchedule() {
      if(localStorage.forceHideMessages == 1){
        console.log("DO NOT SHOW MESSAGE MODAL DUE forceHideMessages flag")
        return;
      }
      this.loadAllCounters((err,all_counter_data)=>{
        this.$ajax.post("/" + this.api_name + "/get_list/", {}, (err, message_data) => {
          console.log(err, message_data);
          this.showNoticeData({all_counters:all_counter_data},message_data);
        });
      });
    },
    processNoticeModal(data) {
      if(localStorage.forceHideMessages == 1){
        console.log("DO NOT SHOW MESSAGE MODAL DUE forceHideMessages flag")
        return;
      }
      debug_msg("processNoticeModal");
      this.$ajax.post("/" + this.api_name + "/get_list/", {}, (err, result) => {
        var hash = md5(JSON.stringify(result))
        if(window.sessionStorage.getItem('last_notification_hash') != hash){
          this.$store.state.show_message_after_login = true;
        }
        window.sessionStorage.setItem('last_notification_hash', hash)
        if (this.$store.state.show_message_after_login == false) {
          return;
        }
      //  if(Array.isArray(result) && result.length >0){
         this.showNoticeData(data,result);
      //  }
      });
    },
    closed(mode) {
      this.showModal = false;
    },
    checkNoticiesForSchedule(vm){
      var noticiesForSchedule = Vue.localStorage.get("noticiesForSchedule")
      if(noticiesForSchedule && noticiesForSchedule.length > 8){
        noticiesForSchedule = JSON.parse(noticiesForSchedule);
        if(vm.schedule_interval == false){
          vm.schedule_interval = []
        }else if( Array.isArray(vm.schedule_interval) && vm.schedule_interval.length > 0){
          vm.schedule_interval.forEach(cancel_time =>{
            clearTimeout(cancel_time);
          });
          vm.schedule_interval = []
        }
        noticiesForSchedule.forEach(time =>{
          var wait_seconds = moment(time).diff(new Date(),"seconds");
          if(wait_seconds > 0){
            console.log('Setup timer for',time,'in',wait_seconds,'seconds');
            vm.scheduler_is_listening = true;
            vm.schedule_interval.push(setTimeout(()=>{
              // return bus.$emit("processNoticeModalSchedule",{});
              window.sessionStorage.setItem('alert_for_'+moment(time).format("YYYYMMDDHHmmss"),"done")
              vm.processNoticeModalSchedule()
            },wait_seconds * 1000 ))
          }else{
            if(window.sessionStorage.getItem('alert_for_'+moment(time).format("YYYYMMDDHHmmss")) != "done"){
              vm.processNoticeModalSchedule()
            }
          }
        })
      }
    }
  },
  mounted() {
    if(this.$props.tag != "no"){
      bus.$on(this.$props.tag, this.processNoticeModal);
    }
    if(this.$props.stag != "no"){
      bus.$on(this.$props.stag, this.processNoticeModalSchedule);
    }
    var today = moment(new Date()).format("YYYY/MM/DD")
    var passwordExpireDate = Vue.localStorage.get("passwordExpireDate") || (new Date())
    this.loginExpireDays = moment(passwordExpireDate).diff(today, 'days') 

    this.checkNoticiesForSchedule(this)

  },
  beforeDestroy() {
    if( Array.isArray(this.schedule_interval) && this.schedule_interval.length > 0){
      this.schedule_interval.forEach(time =>{
        clearTimeout(time);
      });
      this.schedule_interval = []
    }
    if(this.$props.tag != "no"){
      bus.$off(this.$props.tag);
    }
    if(this.$props.stag != "no"){
      bus.$off(this.$props.stag);
    }
  },
  props: {
    tag: { type: String, default: "no" },
    stag: { type: String, default: "no" },
  },
};
</script>
<style scoped>
.message_label {
  font-weight: bolder;
}
.notice-modal-body {
  height: 250px;
  overflow-y: auto;
}

.info_div {
  width: 32%;
  float: left;
}
.esma_td2 {
  margin: 2px 0px;
  border: 0px solid #bdbdbd;

  font-size: 11px;
  font-weight: 500;
  padding: 4px 0px 4px 4px;
}

.esma_td_h2 {
  margin: 2px 0px;
  _border: 1px solid #bdbdbd;
  _background-color: #b4d5f1;
  padding: 4px 8px;
  font-size: 11px;
  _font-weight: 900;
}
</style>



// WEBPACK FOOTER //
// notice-modal.vue?4debbd2e